/** @see: src/errors/app.ts */

export enum ErrorMessage {
  // FatalErrors - Fullpage
  SYSTEM_ERROR = 'SYSTEM_ERROR',
}

export enum ErrorCode {
  UNKNOWN = 'unknown-error',
  FATAL_ERROR = 'FATAL_ERROR',
  FATAL = 'fatal',
  NOT_FOUND = 'not-found',
  PERMISSION_DENIED = 'forbidden',
  IMPLEMENTATION_DEFECT = 'implementation-defect',
  INTERNAL = 'internal',
  INTERNAL_1 = 'INTERNAL',
  INVALID_TENANT_ID = 'invalid-tenant-id',
  INCOMPLETE_OPERATION = 'incomplete-operation',
  SESSION_EXPIRED = 'session-expired',
  TENANT_NOT_FOUND = 'tenant-not-found',
  INVALID_CREDENTIALS = 'invalid-credentials',
  ACCOUNT_LOCKED = 'idp-locked',
}

export enum ErrorScreens {
  ACCOUNT_LOCKED = 'idp-locked',
}
